module.exports = __webpack_public_path__ + "img/icon4.1945a552.png";